var _path, _path2, _path3, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.188 41.611C37.9835 41.4651 23.7488 41.3275 16.0789 41.4556C13.0207 41.5066 10.0062 39.834 8.61565 37.1098L3.25934 26.6164C1.47197 23.1149 2.91797 18.8284 6.46117 17.1251L31.751 4.96742C33.7376 4.01236 36.0581 4.04888 38.0138 5.066L56.5416 14.7022C59.6633 16.3258 61.0947 20.0144 59.8851 23.3187L54.8727 37.0119C53.8481 39.8112 51.1686 41.6537 48.188 41.611Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8991 5.18218L20.1788 0.902461C20.9667 0.114544 22.2494 0.114544 23.0373 0.902461L24.6884 2.5536C25.6456 3.51082 26.1666 4.79302 26.1666 6.11918C26.1666 6.44921 26.1343 6.78277 26.0681 7.11431C25.9801 7.55351 25.828 7.9654 25.637 8.35406L31.2094 13.9261L33.4968 11.6386C34.1286 11.0069 35.1525 11.0069 35.7837 11.6386L39.2143 15.0693C41.7408 17.5958 41.5017 24.218 40.358 25.3617C39.2143 26.5054 32.5922 26.7445 30.0657 24.218L26.6351 20.7874C26.0034 20.1556 26.0034 19.1317 26.6351 18.5004L28.9225 16.213L23.3501 10.6405C22.9609 10.832 22.548 10.9842 22.1083 11.0721C20.4502 11.4036 18.746 10.8881 17.5502 9.69235L15.8991 8.04121C15.1107 7.25279 15.1107 5.9706 15.8991 5.18218ZM19.8371 7.40542C20.0483 7.61654 20.3084 7.77222 20.5942 7.85863C20.8801 7.94504 21.1828 7.95949 21.4756 7.90071C22.1948 7.75617 22.7527 7.1977 22.8973 6.47701C23.015 5.87912 22.8311 5.2686 22.402 4.84053L21.6085 4.04705L19.0437 6.61195L19.8371 7.40542Z",
    fill: "#F0AE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6839 16.9645C14.8723 14.9662 14.6033 23.0919 15.8202 27.4046H51.5599C51.9442 24.5651 51.8033 18.0022 48.1653 14.4666C43.6178 10.0472 39.1983 19.4625 25.6839 16.9645Z",
    fill: "#FDEFCE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.90283,
    y: 21.832,
    width: 48.5496,
    height: 4.99587,
    rx: 2.49793,
    fill: "#677788"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7211,
    y: 26.1875,
    width: 42.9132,
    height: 10.8884,
    rx: 5.44421,
    fill: "#677788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default __webpack_public_path__ + "static/media/sandbox.0eb6a590f2de50ba35044a0d46fbd923.svg";
export { ForwardRef as ReactComponent };